// const { v4 } = require('uuid');
const {
  isPlainObject
} = require('lodash');
const {
  evaluateSource
} = require(/* webpackIgnore: true */'../lib/evaluateSource');

/**
 * @function evaluate - evaluates generateCollectionContentBehavior
 *
 * Generates collection content by taking a content `template`
 * and repeating it `count` times. Primarily for performance testing.
 */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const evaluateTemplate = async (template, index) => {
    if (!isPlainObject(template)) {
      return template;
    }
    const result = {};
    const keys = Object.keys(template);
    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      let tmp = template[key];
      if (tmp === '{index}') {
        tmp = index;
      } else {
        /* eslint-disable-next-line no-await-in-loop */
        tmp = await evaluateSource(tmp, content, parentContentPath, transientContext, nativeFunctions);
      }
      result[key] = tmp;
    }
    return result;
  };
  const result = {};
  const count = await evaluateSource(source.count, content, parentContentPath, transientContext, nativeFunctions);
  for (let i = 0; i < count; i += 1) {
    // crypto.getRandomValues() doesn't appear
    // to be supported in JavaScriptCore
    // const uuid = v4().toUpperCase();
    const uuid = `item${i}`;
    /* eslint-disable-next-line no-await-in-loop */
    result[uuid] = await evaluateTemplate(source.template, i);
  }
  return result;
};
module.exports = {
  evaluate
};